import React from 'react'
import { Toolbar,Grid,Box,Button,Typography} from '@mui/material'
import {styled, useTheme} from '@mui/material/styles';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';


export const Footer=styled(Toolbar)(
    ({theme})=> `
    background-color:${theme.palette.primaryTheme.shade07};
    height:44px;
    position:fixed;
    bottom:0px;
    justify-content:center;
    text-align:center;
    z-index:999;
    ${theme.breakpoints.up('mobile')}{
      min-height:32px;
    }
   `
  )
 
function SettingsFooterPopup(props) {
  const theme=useTheme();
  // undefined => legacy always-show for callers that have not wired dirty tracking yet
  const hasUnsavedChanges = props.hasUnsavedChanges !== false;
  const justSaved = props.justSaved === true;
  const showActions = hasUnsavedChanges && !justSaved;

  if (!showActions && !justSaved) {
    return null;
  }
  
  return (
    <>
      <Footer sx={{borderTop: `1px solid ${theme.palette.primaryTheme.shade03}`,width:`calc(80vw)` }} >
      <Grid  container >
                <Grid item mobile={4} tablet={6} laptop={6} >
                    <Box display="flex" justifyContent="flex-start" alignItems="center" sx={{width:"100%",height:"100%",textAlign:'center'}}>
                    {!justSaved && (
                    <Button variant="outline" onClick={()=>props.discardChanges()} sx={{mr:1,fontSize:"12px",height:36,borderRadius:"1px",fontColor:"#0d203f",color:"#0d203f",border:'1px solid #0d203f'}}>
                      Discard Changes
                    </Button>
                    )}
                    </Box>
                </Grid>
                
                <Grid item mobile={8} tablet={6} laptop={6} >
                  <Box display="flex" sx={{height:"100%"}} justifyContent="end" alignItems="center">
                    {justSaved ? (
                      <Box display="flex" alignItems="center" sx={{mr:1}}>
                        <CheckCircleOutlineRoundedIcon sx={{color:'#2e7d32',fontSize:20,mr:0.5}} />
                        <Typography sx={{fontSize:13,color:'#2e7d32',fontWeight:600}}>Saved</Typography>
                      </Box>
                    ) : (
                    <Button variant="contained" onClick={()=>props.saveSettings()} sx={{mr:0,fontSize:"12px",height:36,borderRadius:"0px"}}>
                      Save Settings
                    </Button>
                    )}
                  </Box>
                </Grid>
            </Grid>
      </Footer>
    </>
  )
}

export default SettingsFooterPopup
